import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import DataTable from './DataTable';
import SearchForm from './SearchForm';
import { SIZE_PER_PAGE } from './config';
import FilterCompletedSteps from './FilterCompletedSteps';

function ResultsDeals({
  tableDefinition,
  dealer,
  page,
  dealTotal,
  dealList,
  disabled,
  updatePage,
  updateCustomerName,
  updateFilteredSteps,
}) {
  const [expandedDeals, setExpandedDeals] = useState([]);
  const toggleDealExpand = (dealId) => {
    if (expandedDeals.includes(dealId)) {
      setExpandedDeals(expandedDeals.filter((id) => id !== dealId));
    } else {
      setExpandedDeals([...expandedDeals, dealId]);
    }
  };

  const renderDealCell = (cell, data, column) => (
    <>
      {cell}
      {expandedDeals.includes(data.id) &&
        column &&
        column.expandedCellFormat && (
          <div className="results-deals-details">
            {column.expandedCellFormat(data, { dealer })}
          </div>
        )}
    </>
  );

  const rowMouseDownPositionRef = useRef();

  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="results-deals-header">
          <div>
            <div className="data-table-label">Deal Progress by Customers</div>
            <SearchForm
              placeholder="Customer Name"
              onSubmit={updateCustomerName}
              disabled={disabled}
            />
          </div>
          <div>
            <div className="data-table-label">Must have Completed</div>
            <FilterCompletedSteps
              onChange={updateFilteredSteps}
              disabled={disabled}
              tableDefinition={tableDefinition}
            />
          </div>
        </div>
        <DataTable
          remote
          pagination
          data={dealList}
          config={tableDefinition}
          fetchInfo={{ dataTotalSize: dealTotal }}
          options={{
            hideSizePerPage: true,
            page,
            sizePerPage: SIZE_PER_PAGE,
            onPageChange: updatePage,
            onRowMouseDown: (data, e) => {
              rowMouseDownPositionRef.current = { x: e.pageX, y: e.pageY };
            },
            onRowClick: (data, c, r, e) => {
              // only process the row click if the mouse hasn't moved much from the initial mouse down
              // this allows text selection in the row
              if (
                !rowMouseDownPositionRef.current ||
                (Math.abs(e.pageX - rowMouseDownPositionRef.current.x) < 5 &&
                  Math.abs(e.pageX - rowMouseDownPositionRef.current.x) < 5)
              ) {
                toggleDealExpand(data.id);
              }
              rowMouseDownPositionRef.current = null;
            },
          }}
          renderCell={renderDealCell}
          trClassName="results-deals-row"
        />
      </div>
    </div>
  );
}

ResultsDeals.propTypes = {
  tableDefinition: PropTypes.object.isRequired,
  dealer: PropTypes.object,
  page: PropTypes.number,
  dealTotal: PropTypes.number,
  dealList: PropTypes.array,
  disabled: PropTypes.bool,
  updatePage: PropTypes.func.isRequired,
  updateCustomerName: PropTypes.func.isRequired,
  updateFilteredSteps: PropTypes.func.isRequired,
};

export default ResultsDeals;
